import { request } from '@umijs/max';

import { DeleteRequest } from '@/types';

import {
  ClassLabelOption,
  ClassLabelResponse,
  CreateClassLabelRequest,
  EditClassLabelRequest,
  ManageClassLabelResponse,
} from './types';

export async function getClassLabels(): Promise<ClassLabelResponse[]> {
  return request('class-labels', {
    method: 'GET',
  });
}

export async function getClassLabelDefectSets(): Promise<ClassLabelOption[]> {
  return request('class-labels/defect-sets', {
    method: 'GET',
  });
}

export async function getClassLabelViewSets(): Promise<ClassLabelOption[]> {
  return request('class-labels/view-sets', {
    method: 'GET',
  });
}

export async function createClassLabel(payload: CreateClassLabelRequest): Promise<ManageClassLabelResponse> {
  return request('class-labels', {
    data: payload,
    method: 'POST',
  });
}

export async function editClassLabel({ id, ...payload }: EditClassLabelRequest): Promise<ManageClassLabelResponse> {
  return request(`class-labels/${id}`, {
    data: payload,
    method: 'PATCH',
  });
}

export async function deleteClassLabel({ id }: DeleteRequest): Promise<ManageClassLabelResponse> {
  return request(`class-labels/${id}`, {
    method: 'DELETE',
  });
}
